import React from 'react';
import clsx from 'clsx';
import styles from './closeButton.module.css';
import { CustomCircularProgress } from '@/components/Loading/CustomCircularProgress';

const CloseButton = ({
  text,
  onClick,
  borderColor,
  color,
  loading,
  width,
  className,
}) => {
  return (
    <button
      className={clsx(styles.container, className)}
      onClick={onClick}
      style={{ borderColor: borderColor, width: width }}>
      {loading ? (
        <CustomCircularProgress className="w-4 h-4 border-primary-text" />
      ) : (
        <span style={{ color: color }} className={styles.text}>
          {text}
        </span>
      )}
    </button>
  );
};

export default CloseButton;
